// import { ErrorHandler, NgModule } from '@angular/core';
// import Bugsnag from '@bugsnag/js'
// import { BugsnagErrorHandler } from '@bugsnag/plugin-angular';
// // import BugsnagPerformance from '@bugsnag/browser-performance'
// import { environment } from 'src/environments/environment'

// if (environment.production) {
//   Bugsnag.start({
//     apiKey: environment.bugsnag,
//     onError: (err) => {
//       const error = err.errors?.[0];
//       if (!error) return true;
//       const exclude = /HttpErrorResponse|ChunkLoadError|Zone|zone\.js/i;
//       if (exclude.test(error?.errorClass) || exclude.test(error?.errorMessage) || error?.stacktrace?.some(f => exclude.test(f?.file))) {
//         return false;
//       }
//       return true;
//     }
//   });
//   // BugsnagPerformance.start({ apiKey: environment.bugsnag });
// }

// export function errorHandlerFactory() {
//   return environment.production ? new BugsnagErrorHandler() : '';
// }

// @NgModule({
//   imports: [],
//   providers: [
//     environment.production ? { provide: ErrorHandler, useFactory: errorHandlerFactory } : []
//   ]
// })

// export class ErrorHandlerModule { }

import { ErrorHandler, Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class LazyBugsnagErrorHandler implements ErrorHandler {
  private started = false;
  private angularHandler: ErrorHandler | null = null;

  async handleError(error: any) {
    if (!environment.production || typeof window === 'undefined') {
      console.error(error);
      return;
    }

    if (!this.started) {
      const Bugsnag = (await import('@bugsnag/js')).default;
      await import('@bugsnag/plugin-angular'); // side-effect import

      Bugsnag.start({
        apiKey: environment.bugsnag,
        onError: (event) => {
          const error = event.errors?.[0];
          if (!error) return true;
          const exclude = /HttpErrorResponse|ChunkLoadError|Zone|zone\.js|pagesense\.io|usercentrics|termageddon|googletagmanager/i;
          if (exclude.test(error.errorClass) || exclude.test(error.errorMessage) || error.stacktrace?.some(f => exclude.test(f.file))) {
            return false;
          }
          return true;
        }
      });

      // Plugin is already registered internally
      this.angularHandler =
        Bugsnag.getPlugin('angular')?.createErrorHandler() ?? null;

      this.started = true;
    }

    this.angularHandler?.handleError(error);
  }
}
